export default __webpack_public_path__ + "media/images/external-link-27d7b9ef.svg";